import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { computed, onBeforeUnmount, onMounted, ref } from "vue"
import { Refresh } from "@element-plus/icons-vue"
import ComTooltip from "@/components/common/ComTooltip.vue"
import { useBimMallit } from "@/methods/bimComposables"
import { bimKaytossa } from "@/bim-http"
import * as malliIkkuna from "./malliIkkuna"
import { useMalliLinkki } from "./malliLinkki"

interface Props {
    hankeId: number
}


const __default__ = {
    name: "ComMalliNappi",
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    hankeId: {}
  },
  setup(__props: any) {

const props = __props
const hankeId = computed(() => props.hankeId)

/** Nappi nakyy jos hankkeelle on malli. Tarkistetaan mallirekisterista eika
 *  vertailusta: vertailu hakee kaikki hankkeen huonekortit, eika sita saa
 *  tehda pelkan napin nakyvyyden takia. */
const { mallit } = useBimMallit()
const bimSaatavilla = computed(
    () => bimKaytossa && !!mallit.value?.some((m) => m.hankeId === hankeId.value || m.oletus)
)

// avaaMalli tulee malliLinkista, joka on myos ainoa paikka joka tyontaa
// paivittyneen vertailun avoimeen ikkunaan ("Paivita vertailu" -nappi).
const { loading, fetching, paivita, avaaMalli } = useMalliLinkki(hankeId)

/** `malliIkkuna.auki()` ei ole reaktiivinen — ikkunan sulkeminen ei laukaise
 *  Vahdissa tapahtumaa. Tila luetaan siksi klikkausten yhteydessa ja
 *  ikkunaan kohdistuvien tapahtumien jalkeen. */
const ikkunaAuki = ref(false)
const nappiteksti = computed(() => (ikkunaAuki.value ? "Näytä malli" : "Avaa malli"))

const avaa = () => {
    avaaMalli()
    ikkunaAuki.value = malliIkkuna.auki()
}

// Ikkunan sulkemisesta ei tule Vahtiin tapahtumaa, joten nappiteksti
// tarkistetaan kun kayttaja palaa Vahtiin. Ilman tata nappi lupaisi
// "Nayta malli" ikkunalle jota ei enaa ole.
const tarkistaIkkuna = () => { ikkunaAuki.value = malliIkkuna.auki() }
onMounted(() => {
    tarkistaIkkuna()
    window.addEventListener("focus", tarkistaIkkuna)
})
onBeforeUnmount(() => window.removeEventListener("focus", tarkistaIkkuna))

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_button_group = _resolveComponent("el-button-group")!

  return (bimSaatavilla.value)
    ? (_openBlock(), _createBlock(_component_el_button_group, { key: 0 }, {
        default: _withCtx(() => [
          _createVNode(_component_el_button, {
            size: "small",
            loading: _unref(loading),
            onClick: avaa
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(nappiteksti.value), 1)
            ]),
            _: 1
          }, 8, ["loading"]),
          _createVNode(ComTooltip, { content: "Päivitä vertailu" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_button, {
                size: "small",
                loading: _unref(fetching),
                onClick: _unref(paivita)
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_icon, null, {
                    default: _withCtx(() => [
                      _createVNode(_unref(Refresh))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["loading", "onClick"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}
}

})